(function() {
    angular
        .module("alertsModule", [
            "ui.router"
        ])
})()
